export default __webpack_public_path__ + "2df485f5a092bf212d59637645c29db7.svg";